import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { CabeceraModule } from "../../../components/common/cabecera/cabecera.module";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";

import { AplicacionesTransporteModule } from "../aplicacionesTransporte/aplicaciones-transporte.module";
import { SolicitudVehiculosModule } from "../solicitudes/solicitud-vehiculos.module";
import { SolicitudEquiposModule } from "../solicitudes/solicitud-equipo.module";
import { SolicitudOtrosModule } from "../solicitudes/solicitud-otros.module";
import { PolizasVencidasNoLiberadasService } from "../fianzas/polizasVencidasNoLiberadas/polizas-vencidasnoLiberadas.service";
import { RedesEmpresaModule } from "../vamEmpresa/redes/redesEmpresa.module";
import { CondicionesVamModule } from "../vamEmpresa/condiciones/condiciones.module";
import { MovimientosVamModule } from "../vamEmpresa/movimientos/movimientosVam.module";
import { ListadosModule } from "../vamEmpresa/listados/listados.module";
import { SolicitudMovimientosModule } from "../vamEmpresa/solicitudes/solicitudes-movimientos.module";
import { CalendarModule } from 'primeng/primeng';
import {ResumenGrComponent} from '../polizasContratadas/resumengr.component';
import { ChartsModule } from 'ng2-charts'
import { RankingTitularesGrComponent } from "../polizasContratadas/rankingTitularesgr.component";
import {DetalleDiagnosticoComponentGr} from '../polizasContratadas/detalle-diagnosticogr.componet';
import {ProveedoresComponentGr} from '../polizasContratadas/proveedoresgr.component';
import {MaternidadComponentGr} from '../polizasContratadas/maternidadgr.component';
import { detalleCreditoService } from "./detalleCredito.service";
import { detalleCredito } from "./detalleCredito.component";


@NgModule({
    declarations: [detalleCredito],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        CabeceraModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        Ng2Webstorage,
        AplicacionesTransporteModule,
        SolicitudVehiculosModule,
        SolicitudEquiposModule,
        SolicitudOtrosModule,
        RedesEmpresaModule,
        CondicionesVamModule,
        ListadosModule,
        MovimientosVamModule,
        CalendarModule,ChartsModule,
        SolicitudMovimientosModule],
        exports: [detalleCredito],
    providers: [detalleCreditoService,PolizasVencidasNoLiberadasService]
})

export class SeguroCreditoModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/seguroCredito/detalleCredito.module.ts